module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Db-Fb-Gc-Hc-Ia.86ae2be7.png";